import { createContext, useContext } from 'react';

interface BrandingMigrationContextValue {
    isBrandedJobMigrationTestActive: boolean;
    isBrandedJobMigrationShadow: boolean;
}

const BrandingMigrationContext = createContext<BrandingMigrationContextValue>({
    isBrandedJobMigrationTestActive: false,
    isBrandedJobMigrationShadow: false,
});

export const useBrandingMigrationFlags = () => useContext(BrandingMigrationContext);

export const BrandingMigrationProvider = BrandingMigrationContext.Provider;
